import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pop-up-info',
  templateUrl: './pop-up-info.component.html',
  styleUrls: ['./pop-up-info.component.scss']
})
export class PopUpInfoComponent implements OnInit {

 


  @Input() modalName: string;
  @Input() info: string[];
  
  constructor() {
      this.modalName = "";
      this.info = [];
    }
  
    ngOnInit(): void {
      
    }
  
  disp() {
    console.log(this.info);
  }
  
  
  }
  
